var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[(_vm.loadingPaymentMethods)?_c('Loading'):_c('PaymentMethodList',{attrs:{"payments":_vm.allPaymentMethods}}),_c('SnackBar',{attrs:{"snackbar":_vm.notification.success,"text":_vm.notification.message}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }